















import { Component, Prop, Vue } from "vue-property-decorator";
import { getCardColor } from "@/utils/ProjectOverviewUtils";
import {
  COLOR_DARK_FILL_OUTLINE_BACKGROUND,
  COLOR_DARK_FILL_OUTLINE_BORDER,
  COLOR_DARK_FILL_OUTLINE_TEXT,
  COLOR_STANDARD_WHITE,
} from "@/utils/colors";
import { themedFill, themedFillTextColor } from "@/utils/Theme";

/**
 * A project's step boxes in the admin portal's project list, as IRES Admin shows them: one box per
 * step, green finished, yellow started, white not reached. The colours and the dark-mode outline for
 * a not-reached step follow `ProjectOverviewStatus`, so a box reads the same as in IRES Office.
 *
 * Deliberately simpler than `ProjectOverviewStatus`, which needs the whole overview entry: the portal
 * only receives the step flags, and shows every box for every project, as IRES Admin does.
 */
@Component
export default class ClientProjectStepsComponent extends Vue {
  /** true finished, false started, null not reached. */
  @Prop({ required: true }) steps!: Array<boolean | null>;

  /** A not-reached step in dark mode: white would glare, so it is an outline instead. */
  isNotStartedOutline(step: boolean | null): boolean {
    return this.$vuetify.theme.dark && getCardColor(step) === COLOR_STANDARD_WHITE;
  }

  tileColor(step: boolean | null): string {
    return this.isNotStartedOutline(step) ? COLOR_DARK_FILL_OUTLINE_BACKGROUND : themedFill(getCardColor(step));
  }

  tileStyle(step: boolean | null): Record<string, string> {
    if (this.isNotStartedOutline(step)) {
      return {
        border: `1px solid ${COLOR_DARK_FILL_OUTLINE_BORDER}`,
        color: COLOR_DARK_FILL_OUTLINE_TEXT,
        boxShadow: "none",
      };
    }

    return { color: themedFillTextColor(getCardColor(step), "") };
  }
}
